import script from "./LoginOverture.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginOverture.vue?vue&type=script&setup=true&lang=ts"

import "./LoginOverture.vue?vue&type=style&index=0&id=c5028158&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5028158"]])

export default __exports__